export default __webpack_public_path__ + "static/media/implementer.873c13d5.png";